import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../layouts';
import '../../../../assets/scss/resumopf.scss';
import configBase from '../../../../configBase';
import axios from 'axios';
import InputMask from 'react-input-mask';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import {DropzoneDialog} from 'material-ui-dropzone';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from "date-fns/locale/pt-BR";
import ReactToPrint from 'react-to-print';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import SendIcon from '@material-ui/icons/Send';
import CancelScheduleSendIcon from '@material-ui/icons/CancelScheduleSend';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PrintIcon from '@material-ui/icons/Print';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

import {
  ScrollableTabsButtonAuto
} from './components';


// Perfis que podem cancelar proposta PJ pelo painel.
// Para liberar outros perfis, acrescente aqui (ex.: 'REGISTER', 'AFTER SALES', 'BACKOFFICE').
const PERFIS_CANCELAMENTO_PJ = ['ADMIN'];

// Status em que o cancelamento fica só no Intelite: sem contrato no S4 e sem valor pago.
// Fora dessa lista o cancelamento envolve baixa no S4e e/ou estorno na P4X.
const STATUS_CANCELAMENTO_PJ = [
  'AGUARDANDO CONFIRMAÇÃO',
  'AGUARDANDO PAGAMENTO',
  'VALIDANDO EMPRESA',
  'EM PROCESSAMENTO',
  'EM VALIDAÇÃO',
  'PENDENTE'
];


class ResumoPropostaPJ extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      detailsData: 'loading',
      detailsDataLoadingMsg: 'VALIDANDO A PROPOSTA...',

      stateList: [],
      addressTypeList: [],
      cityList: [],
      districtList: [],
      pendencyList: [],
      cardFlagList: [],

      modalConfirmOpen: false,
      modalConfirmLoading: false,
      cancellationsList: [],
      modalConfirmQuestionContent: '',
      modalConfirmActionType: '',
      modalConfirmButton: '',
      modalConfirmButtonLoading: false,
      modalConfirmQuestion: false,
      fieldCancel: 'null',
      fieldPending: 'null',

      currentTimeServer: null,
      listYear: [],
      errorRequest: false,
      msgErrorRequest: '',
      snackbarSuccess: false,
      msgSnackbarSuccess: '',

      showFirstPayment: false,
      disabledInput: true,
      disabledInputValuePlan: true,
      disabledInputHolder: true,

      disabledLoadingAddressType: false,
      disabledLoadingAddressNumber: false,
      disabledLoadingAddress: false,
      disabledLoadingAddressComplement: false,
      disabledLoadingState: false,
      disabledLoadingCity: false,
      disabledLoadingDistrict: false,

      fMCity: '',
      fMDistrict: '',

      showActionS4: false,
      showActionSendAfterSales: false,
      showActionPendency: false,
      showActionPendencyField: false,
      showActionCancel: false,
      showActionCancelField: false,
      showActionSendAnalyze: false,
      showActionEmail: false,

      showFileAverbation: false,

      confirm: false,
      confirmCheck: false,
      errorCheck: false,

      dropzoneDialog: false,
      typeFile: '',

      fullScreenModal: false,

      confirmFmMensage: '',

      disabledCardHolderName: true,
      disabledCardNumber: true,
      disabledCardValidity: true,

      planCredtCard: false,

      vencBoleto: '',

      msgSus: 'Caso a proposta esteja revisada, aprovada e pronta para ser efetivada, clique no botão ATIVAR.',
      msgUserTable: '',
      msgContinue: false,


      companyConfirm: false,
      companyData: 'loading',
      disabledCNPJ: false,
      disabledCPF: false,
      disabledAmountUsers: false,
      disableCostCenterS4: false,
      disableEffectiveDate: false,
      disableCarenciaCoberturaS4: false,
      disableAmountHolder: false,
      disableAmountDependent: false,
      disableAmountOrto: false,
      disableValuePlanHolder: false,
      disableValuePlanDependent: false,
      disableIncludesOrto: false,

      showLoadindDowloadPdf: false,

      holderIndex: 0,
      dependentIndex: 0,
      modalAddHolder: false,

      imprimir: true,
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      theadTh:{
        height: 40,
        paddingLeft: 10,
      },
      theadTh2:{
        height: 40,
        paddingLeft: 10,
        backgroundColor: '#eee'
      },
    }

    this.parentageList = {
      "CÔNJUGE/COMPANHEIRO": 3,
      "CONJUGE/COMPANHEIRO": 3,
      "COMPANHEIRO": 3,
      "CONJUGE": 3,
      "CÔNJUGE": 3,
      "FILHO": 4,
      "PAI/MÃE": 8,
      "PAI/MAE": 8,
      "OUTRO": 10,
      "AGREGADO": 10,
      "ENTEADO": 6,
    };

  }


  componentDidMount() {
    this.beforeDetails();
    this.fullScreenModalFn();
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  beforeDetails() {
    let state = this.state;
    let companyId = this.props.history.location.search.replace('?p=', '');

    if (companyId && companyId.length > 0) {
      let url = configBase.api + 'Companies/count?where={"id":"'+companyId+'"}&access_token='+localStorage.getItem('planos_t');

      axios.get(url)
      .then((response) => {
        // Caso encontre a proposta
        if (response.data.count > 0) {




          state.companyDataLoadingMsg = 'BUSCANDO LISTA DE TIPOS DE LOGRADOUROS...';
          this.setState(state);

          axios.get(configBase.api + 'APIS4s/tipoLogradouro?access_token='+localStorage.getItem('planos_t'))
          .then((result) => {
            let state = this.state;
            state.companyDataLoadingMsg = 'BUSCANDO LISTA DE ESTADOS...';
            state.addressTypeList = result.data; // Tipo logradouro
            this.setState(state);

            // Pega a lista de estados
            axios.get(configBase.api + 'APIS4s/UFs?access_token='+localStorage.getItem('planos_t'))
            .then((result) => {
              // Estados
              state.stateList = result.data;
              state.companyDataLoadingMsg = 'BUSCANDO LISTA DE PENDENCIAS...';
              this.setState(state);




              // Pega a lista de pendências
              axios.get(configBase.api + 'Pendencies?access_token='+localStorage.getItem('planos_t'))
              .then((result) => {
                // Pendências
                state.pendencyList = result.data;
                state.companyDataLoadingMsg = 'BUSCANDO LISTA DE CANCELAMENTOS...';
                this.setState(state);

                // Pega a lista de cancelamentos
                axios.get(configBase.api + 'Cancellations?access_token='+localStorage.getItem('planos_t'))
                .then((result) => {
                  // Cancelamentos
                  state.cancellationsList = result.data;
                  state.companyDataLoadingMsg = 'VERIFICANDO DATA E HORA ATUAL...';
                  this.setState(state);

                  // Pega a data atual do servidor
                  axios.post(configBase.api + 'Sales/currentTime?access_token='+localStorage.getItem('planos_t'))
                  .then((response) => {
                    // Hora atual do servidor
                    state.currentTimeServer = response.data;
                    state.companyDataLoadingMsg = 'BUSCANDO DADOS DA PROPOSTA...';
                    this.setState(state);

                    this.getDetails(companyId);
                  })
                  .catch(function () {
                    this.setError('Problema encontrado ao verificar a data e hora atual', 'error');
                  }.bind(this));
                })
                .catch(function () {
                  this.setError('Problema encontrado ao buscar a lista de Cancelamentos', 'error');
                }.bind(this));
              })
              .catch(function () {
                this.setError('Problema encontrado ao buscar a lista de Pendências', 'error');
              }.bind(this));




            })
            .catch(function () {
              this.setError('Problema encontrado ao buscar a lista dos estados', 'error');
            }.bind(this));
          })
          .catch(function () {
            this.setError('Problema encontrado ao buscar a lista dos tipos de logradouro', 'error');
          }.bind(this));




        }
        else {
          let state = this.state;
          state.companyData = 'zero';
          this.setState(state);
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar dados da proposta', 'error');
      }.bind(this));
    }
    else {
      state.titlePage = '';
      this.setError('A proposta é obrigatória', 'error');
    }

    this.setState(state);
  }

  getDetails(companyId) {
    let dataPost = {
      id: companyId
    };

    let url = configBase.api + 'Companies/getDocsByCompany?access_token='+localStorage.getItem('planos_t');

    axios.post(url, dataPost)
    .then((response) => {
      let state = this.state;
      state.companyData = response.data;

      // Caso a company ainda não tiver confirmado
      if (response.data.companyConfirm === null)
        state.companyConfirm = 'Aguardando confirmação pela empresa.';
      else
        state.companyConfirm = 'Já confirmado pela empresa.';

      if (state.companyData.proposalNumber)
        state.titlePage = ' - '+state.companyData.proposalNumber;

      this.setState(state);

      this.details();
    })
    .catch(function () {
      let state = this.state;
      state.companyData = 'error';
      this.setState(state);
    }.bind(this));
  }

  details() {
    this.rulesOfActions();

    let state = this.state;
    state.modalOpen = true;
    this.setState(state);

    // Atualiza a cidade
    this.getCity();
  }

  rulesOfActions() {
    let state = this.state;
    let typeUser = localStorage.getItem('planos_y');
    let statusCompany = this.state.companyData.status;

    state.showActionField = false;
    state.showActionButton = false;
    state.showActionValidatingCompany = false;
    state.showActionInValidation = false;
    state.showActionAfterSales = false;
    state.showActionPJactivated = false;
    state.showActionOnActivation = false;
    state.showActionRegistrationRefused = false;
    state.showActionPendency = false;
    state.showActionCancel = false;
    state.showActionS4 = false;
    state.disableEffectiveDate = true;
    state.carenciaCoberturaS4Disable = true;

    if (typeUser !== 'PJCADASTRO') {
      state.disabledPlansPjListS4 = true;
    }

    if (typeUser === 'SALESMAN' || typeUser === 'BROKER' || typeUser === 'BACKOFFICE') {
      state.disabledCNPJ = true;
      state.disabledCPF = true;
      state.disabledAmountUsers = true;
      state.disableCostCenterS4 = true;
      state.disableEffectiveDate = true;
      state.disableCarenciaCoberturaS4 = true;
      state.disableAmountHolder = true;
      state.disableAmountDependent = true;
      state.disableAmountOrto = true;
      state.disableValuePlanHolder = true;
      state.disableValuePlanDependent = true;
      state.disableIncludesOrto = true;

      if (statusCompany === 'AGUARDANDO PAGAMENTO')
        state.showActionEmail = true;
      else if (statusCompany === 'AGUARDANDO CONFIRMAÇÃO')
        state.showActionEmail = true;
    }

    if (typeUser === 'PJCADASTRO') {
      state.disableEffectiveDate = false;
      state.carenciaCoberturaS4Disable = false;
    }// Fim PJCADASTRO
    else if (typeUser === 'REGISTER') {
      state.disableEffectiveDate = false;
      state.disabledCNPJ = true;
      state.disabledCPF = true;
      state.disableAmountHolder = true;
      state.disableAmountDependent = true;
      state.disableAmountOrto = true;
      state.disableValuePlanHolder = true;
      state.disableValuePlanDependent = true;
      state.disableIncludesOrto = true;
    }// Fim CADASTRO
    else if (typeUser === 'AFTER SALES') {
      state.carenciaCoberturaS4Disable = false;
      state.disabledCNPJ = true;
      state.disabledCPF = true;
    }

    /*
    * Cancelamento pelo painel: liberado só enquanto a proposta não existe no S4
    * e não há valor pago, porque o cancelamento aqui não baixa contrato no S4e
    * nem estorna na P4X.
    */
    if (PERFIS_CANCELAMENTO_PJ.indexOf(typeUser) >= 0 &&
        STATUS_CANCELAMENTO_PJ.indexOf(statusCompany) >= 0 &&
        !this.temContratoNoS4() &&
        this.state.companyData.situacaoBoleto !== 'PAGO') {

      state.showActionCancel = true;
    }

    this.setState(state);
  }

  // A empresa já foi criada no S4 (daí em diante o cancelamento exige baixa no S4e)
  temContratoNoS4() {
    let codeS4 = this.state.companyData.codeS4;

    return codeS4 !== undefined && codeS4 !== null && codeS4.toString().length > 0;
  }

  // Boleto emitido e ainda pagável: o cancelamento não o baixa
  temBoletoEmAberto() {
    let company = this.state.companyData;

    return company.boletoId !== undefined && company.boletoId !== null && company.boletoId.length > 0 &&
           company.situacaoBoleto !== 'PAGO' && company.situacaoBoleto !== 'BAIXADO';
  }

  getCity() {
    let dataPost = {
      'idUF': parseInt(this.state.companyData.state)
    };

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      this.setState(state);

      // Pega os bairros
      this.getDistrict();
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado', this.state.companyData);
    }.bind(this));
  }

  getDistrict() {
    let dataPost = {
      'idCity': parseInt(this.state.companyData.city)
    };

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade', this.state.companyData);
    }.bind(this));
  }

  updateField(e) {
    let state = this.state;

    if (e.target.name === 'includesOrto')
      state.companyData[e.target.name] = !state.companyData[e.target.name];
    else
      state.companyData[e.target.name] = e.target.value;

    this.setState(state);
  }

  updateDB(field) {
    let dataSubmit = {};

    dataSubmit[field] = this.state.companyData[field];

    axios.post(configBase.api + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {
      
    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados da empresa', this.state.companyData);
    }.bind(this));
  }

  onChangeMonth(event) {
    let state = this.state;
    let month = event.target.value;
    state.companyData.holder.dateFirstPayment = state.companyData.holder.dateFirstPayment.substr(0,4) + month;

    for (let i = 0; i < this.state.companyData.dependents.length; i++) {
      state.companyData.dependents[i].dateFirstPayment = state.companyData.dependents[i].dateFirstPayment.substr(0,4) + month;
    }

    this.updateDependents();
    this.setState(state);
  }

  onChangeYear(event) {
    let state = this.state;
    let year = event.target.value;;
    state.companyData.holder.dateFirstPayment = year + state.companyData.holder.dateFirstPayment.substr(4,6);

    for (let i = 0; i < this.state.companyData.dependents.length; i++) {
      state.companyData.dependents[i].dateFirstPayment = year + state.companyData.dependents[i].dateFirstPayment.substr(4,6);
    }

    this.updateDependents();
    this.setState(state);
  }

  updateDependents() {
    let dataSubmit = {
      financialManagerId: this.state.companyData.id,
      firstPayment: this.state.companyData.holder.dateFirstPayment
    };

    axios.post(configBase.api + 'Dependents/updateFirstPayment?access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do dependente', this.state.companyData);
    }.bind(this));
  }

  updateFieldSales(e) {
    let state = this.state;
    state.companyData.sales[e.target.name] = e.target.value;
    this.setState(state);
  }

  updateDBSales(field) {
    let dataSubmit = {};

    if (this.state.companyData.sales[field]) {
      dataSubmit[field] = this.state.companyData.sales[field];

      axios.post(configBase.api + 'Sales/upsertWithWhere?where={"id":"'+ this.state.companyData.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
      .then(() => {
        
      })
      .catch(function () {
        this.setError('Problema encontrado ao salvar dados da venda', this.state.companyData);
      }.bind(this));
    }
  }

  updateFieldFM(e) {
    let state = this.state;

    if (e.target.name === 'city') {
      state.companyData[e.target.name] = e.target.value;
      state.fMCity = e.target.value;
      this.setState(state);
      this.getDistrict();
    }
    else if (e.target.name === 'district') {
      state.companyData[e.target.name] = e.target.value;
      state.fMDistrict = e.target.value;
      this.setState(state);
    }
    else if (e.target.name === 'state') {
      state.companyData[e.target.name] = e.target.value;
      this.setState(state);
      this.getCity();
    }
    else {
      state.companyData[e.target.name] = e.target.value;
      this.setState(state);
    }
  }

  updateDBFinancialManager(field) {
    let dataSubmit = {};
    let commonFields = [
      'firstName', 'dateOfBirth', 'gender',
      'maritalStatus', 'motherName', 'susNumber'
    ];

    // Retira a máscara da data do cartão
    if (field === 'cardValidity')
      dataSubmit[field] = this.state.companyData[field].replace('/', '');
    else
      dataSubmit[field] = this.state.companyData[field];

    axios.post(configBase.api + 'FinancialManagers/upsertWithWhere?where={"id":"'+ this.state.companyData.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {
      // Verifica se o Responsável Financeiro e o titular são o mesmo
      if (this.state.companyData.cpf === this.state.companyData.holder.cpf) {
        if (commonFields.indexOf(field) >= 0) {
          this.updateFieldHolder(field, null, this.state.companyData[field]);
          this.updateDBHolder(field);
        }
      }

      // Atualiza os dados da proposta na tela
      if (field === 'cardNumber' || field === 'cardFlag')
        this.getDetails(this.state.companyData.id);
    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do responsável financeiro', this.state.companyData);
    }.bind(this));
  }

  updateFieldDate(model, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();;

      if (day < 10)
        day = '0'+ day;
      if (month < 10)
        month = '0'+ month;

      state.companyData[model][field] = year+'-'+month+'-'+day;

      // Salva no banco
      if (model === 'holder')
        this.updateDBHolder(field);
      else
        this.updateDB(field);

      this.setState(state);
    }
  }

  updateFieldHolder(id, event, value=null) {
    let state = this.state;

    if (value === null)
      state.companyData.holder[id] = event.target.value.replace('R$ ', '');
    else
      state.companyData.holder[id] = value.replace('R$ ', '');

    this.setState(state);
  }

  updateDBHolder(field) {
    let dataSubmit = {};

    if (field === 'valuePlan') {
      let value = this.state.companyData.holder[field];

      if (value.indexOf('.') >= 0)
        value = value.split('.');
      else
        value = value.split(',');

      if (value[1]) {
        if (value[1].length === 1) {
          value = value[0] + ',' + value[1] + '0';
        }
        else if (value[1].length === 0) {
          value = value[0] + ',00';
        }
      }
      else {
        value = value[0] + ',00';
      }

      dataSubmit[field] = value;
    }
    else
      dataSubmit[field] = this.state.companyData.holder[field];

    axios.post(configBase.api + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.companyData.holder.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do titular', this.state.companyData);
    }.bind(this));
  }

  updateCurrencydHolder(event, value) {
    let state = this.state;
    state.companyData.holder[event.target.name] = value;
    this.setState(state);
  }

  updateFieldDependent(id, index, event) {
    let state = this.state;
    state.companyData.dependents[index][id] = event.target.value;
    this.setState(state);
  }

  updateDBDependent(field, index) {
    let dataSubmit = {};

    if (field === 'valuePlan') {
      let value = this.state.companyData.dependents[index][field];

      if (value.indexOf('.') >= 0)
        value = value.split('.');
      else
        value = value.split(',');

      if (value[1]) {
        if (value[1].length === 1) {
          value = value[0] + ',' + value[1] + '0';
        }
        else if (value[1].length === 0) {
          value = value[0] + ',00';
        }
      }
      else {
        value = value[0] + ',00';
      }

      dataSubmit[field] = value;
    }
    else
      dataSubmit[field] = this.state.companyData.dependents[index][field];

    axios.post(configBase.api + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.companyData.dependents[index].id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do dependente', this.state.companyData);
    }.bind(this));
  }

  updatedDependentsDate(index, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();;

      if (day < 10)
        day = '0'+ day;
      if (month < 10)
        month = '0'+ month;

      state.companyData.dependents[index][field] = year+'-'+month+'-'+day;

      
      this.updateDBDependent(field, index);

      this.setState(state);
    }
  }

  updateCurrencydDependents(index, event, value) {
    let state = this.state;
    state.companyData.dependents[index][event.target.name] = value;
    this.setState(state);
  }

  getAddress() {
    let valueCep = this.state.companyData.cep;
    let state = this.state;
    state.disabledLoadingAddressType = true;
    state.disabledLoadingAddress = true;
    state.disabledLoadingAddressNumber = true;
    state.disabledLoadingAddressComplement = true;
    state.disabledLoadingState = true;
    state.disabledLoadingCity = true;
    state.disabledLoadingDistrict = true;
    this.setState(state);

    if (valueCep.length >= 8) {
      let dataPost = {
        'cep': valueCep
      };

      axios.post(configBase.api + 'APIS4s/Endereco?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        if (result.data !== null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.companyData.addressType = result.data.IdTipoLogradouro;
          state.companyData.address = result.data.Logradouro;
          state.companyData.state = result.data.IdUf;
          this.setState(state);

          // Salva o Responsável Financeiro no banco
          this.updateDB('cep');
          this.updateDB('addressType');
          this.updateDB('address');
          this.updateDB('state');

          this.getCityEdit(function (stateCity) {
            stateCity.companyData.addressType = result.data.IdTipoLogradouro;

            stateCity.companyData.city = result.data.IdMunicipio;
            stateCity.fMCity = result.data.Municipio;
            this.setState(stateCity);

            this.getDistrictEdit(function (stateDistrict) {
              // Salva o Responsável Financeiro no banco
              this.updateDB('city');

              stateDistrict.companyData.district = result.data.IdBairro;
              stateDistrict.fMDistrict = result.data.Bairro;

              // Salva o Responsável Financeiro no banco
              this.updateDB('district');

              document.getElementById('fm_addressNumber').focus();

              stateDistrict.disabledLoadingAddressType = false;
              stateDistrict.disabledLoadingAddress = false;
              stateDistrict.disabledLoadingAddressNumber = false;
              stateDistrict.disabledLoadingAddressComplement = false;
              stateDistrict.disabledLoadingState = false;
              stateDistrict.disabledLoadingCity = false;
              stateDistrict.disabledLoadingDistrict = false;
              this.setState(stateDistrict);
            }.bind(this));
          }.bind(this));
        }
        else {
          let state = this.state;
          state.disabledLoadingAddressType = false;
          state.disabledLoadingAddress = false;
          state.disabledLoadingAddressNumber = false;
          state.disabledLoadingAddressComplement = false;
          state.disabledLoadingState = false;
          state.disabledLoadingCity = false;
          state.disabledLoadingDistrict = false;
          this.setError('CEP inválido', this.state.companyData);
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar endereço pelo CEP', this.state.companyData);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.disabledLoadingAddressType = false;
      state.disabledLoadingAddress = false;
      state.disabledLoadingAddressNumber = false;
      state.disabledLoadingAddressComplement = false;
      state.disabledLoadingState = false;
      state.disabledLoadingCity = false;
      state.disabledLoadingDistrict = false;
      this.setState(state);
    }
  }

  getCityEdit(cb=null) {
    let chosenState = 0;
    chosenState = this.state.companyData.state;

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      state.disabledLoadingCity = false;

      this.setState(state);

      if (cb !== null)
        cb(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado', this.state.companyData);
    }.bind(this));
  }

  getDistrictEdit(cb=null) {
    let chosenCity = 0;
    chosenCity = this.state.companyData.city;
    let dataPost = {
      idCity: parseInt(chosenCity)
    };

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);

      if (cb !== null)
        cb(state);
    })
    .catch(function (error) {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade', this.state.companyData);
    }.bind(this));
  }

  setError(msg, contentTable='error') {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    state.companyData = contentTable;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  openWindow(image, title) {
    let url = `${process.env.PUBLIC_URL}/visualizardoc?doc=${image}`;

    window.open(
      url,
      title,
      "location,status,scrollbars,resizable,width=800, height=800"
    );
  }

  dropzoneDialogOpen(typeFile=null) {
    let state = this.state;
    state.dropzoneDialog = true;

    if (typeFile !== null)
      state.typeFile = typeFile;

    this.setState(state);
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", "address", "cnpj", "physicalContract1", "physicalContract2", "others", "physicalContract3"
    */

    let reader = new FileReader();
    let file = files[0];
    /* let state = this.state;
    state.companyData.imagesDoc[this.state.typeFile] = '';
    this.setState(state); */

    reader.onloadend = function() {
      let dataSubmit = {
        id: this.state.companyData.id,
        imagesDocId: this.state.companyData.imagesDoc.id,
        imagesDocs: {
          cpf: '',
          rg: '',
          rg2: '',
          cnpj: '',
          address: '',
          physicalContract1: '',
          physicalContract2: '',
          physicalContract3: '',
          others: '',
        }
      };

      dataSubmit.imagesDocs[this.state.typeFile] = reader.result;

      axios.post(configBase.api + 'Companies/saveDocsCompany?access_token='+localStorage.getItem('planos_t'), dataSubmit)
      .then((response) => {
        let state = this.state;
        state.companyData.imagesDoc = response.data;

        let ext = state.companyData.imagesDoc[this.state.typeFile].substr(
          state.companyData.imagesDoc[this.state.typeFile].length - 3,
          state.companyData.imagesDoc[this.state.typeFile].length
        ).toLowerCase();

        state.companyData.imagesDoc[this.state.typeFile] = state.companyData.imagesDoc[this.state.typeFile]+'?v='+new Date().getTime()+ext;
        this.setState(state);

        this.dropzoneDialogClose();

        this.forceUpdate();
      })
      .catch(function () {
        this.setError('Problema encontrado ao salvar documento', this.state.companyData);
      }.bind(this));

    }.bind(this);
    reader.readAsDataURL(file);
  }

  handleConfirmOpen(question, action, txtButton) {
    /*
    * @action pode ser: "cancel", "pending", "analyze", "activate", "sus", "email"
    */

    let state = this.state;
    state.modalConfirmOpen = true;
    state.modalConfirmQuestionContent = question;
    state.modalConfirmActionType = action;
    state.modalConfirmButton = txtButton;

    if (action !== 'email')
      state.modalConfirmQuestion = true;

    this.fullScreenModalFn();
  }

  handleConfirmClose () {
    let state = this.state;
    state.modalConfirmOpen = false;
    state.msgSus = 'Caso a proposta esteja revisada, aprovada e pronta para ser efetivada, clique no botão ATIVAR.';
    state.msgUserTable = '';
    state.modalConfirmActionType = '';
    state.msgContinue = false;
    this.setState(state);
  }

  actionsModal() {
    let state = this.state;
    state.modalConfirmQuestion = false;
    this.setState(state);
  }

  updateFieldCancel(e) {
    let state = this.state;
    state.fieldCancel = e.target.value;
    this.setState(state);
  }

  actionCancellationsDB() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let cancelId = this.state.fieldCancel;

    if (cancelId !== 'null') {
      let dataPost = {
        status: "CANCELADO",
        cancellationId: cancelId,
        analyzing: false,
      };
      let url = configBase.api + 'Companies/upsertWithWhere?where={"id":"' + this.state.companyData.id + '"}&access_token='+localStorage.getItem('planos_t');

      // Cancela proposta
      axios.post(url, dataPost)
      .then(() => {

        /* url = configBase.api + 'FinancialManagers/upsertWithWhere?where={"id":"' + this.state.companyData.id + '"}&access_token='+localStorage.getItem('planos_t');
        let now = new Date(
          this.state.currentTimeServer.year,
          (this.state.currentTimeServer.month + 1),
          this.state.currentTimeServer.day,
          this.state.currentTimeServer.hours,
          this.state.currentTimeServer.minutes,
          this.state.currentTimeServer.seconds,
        );

        dataPost = {
          protocoloCancelamento: '416525' + now.getFullYear() +
            ("0" + (now.getMonth() + 1)).substr(-2) +
            ("0" + now.getDate()).substr(-2)+Math.floor(10 + Math.random() * 99) +
            now.getHours() + ("0" +now.getMinutes()).substr(-2)
        };

        // Marca resp financeiro protocolo de cancelamento
        axios.post(url, dataPost)
        .then(() => { */



          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.setState(state);
          this.handleConfirmClose();
          this.snackbarSuccessOpen('Proposta cancelada com sucesso');
          this.getDetails(this.state.companyData.id);





        /* })
        .catch(function () {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.setError('Problema encontrado ao cancelar proposta', this.state.companyData);
        }.bind(this)); */

      })
      .catch(function () {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setError('Problema encontrado ao cancelar proposta', this.state.companyData);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.setError('Escolha o motivo do cancelamento', this.state.companyData);
    }
  }

  updateFieldPending(e) {
    let state = this.state;
    state.fieldPending = e.target.value;
    this.setState(state);
  }

  actionPendencyDB() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let pendencyId = this.state.fieldPending;

    if (pendencyId !== 'null') {
      let dataPost = {
        id: this.state.companyData.id,
        pendencyId: pendencyId,
      };
      let url = configBase.api + 'Companies/SendEmailPendency?access_token='+localStorage.getItem('planos_t');

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setState(state);
        this.handleConfirmClose();
        this.snackbarSuccessOpen('Proposta pendente salva com sucesso');
        this.getDetails(this.state.companyData.id);
      })
      .catch(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setError('Problema encontrado ao salvar proposta como indeferida', this.state.companyData);
      });
    }
    else {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.setError('Escolha o motivo da indeferência', this.state.companyData);
    }
  }

  snackbarSuccessOpen(msg) {
    let state = this.state;
    state.snackbarSuccess = true;
    state.msgSnackbarSuccess = msg;
    this.setState(state);
  }

  snackbarSuccessClose() {
    let state = this.state;
    state.snackbarSuccess = false;
    state.msgSnackbarSuccess = '';
    this.setState(state);
  }

  confirmCheckFn(event) {
    let state = this.state;
    state.confirmCheck = event.target.checked;
    this.setState(state);
  }

  sendAnalyze() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    if (this.state.companyData.status === 'AGUARDANDO PAGAMENTO') {
      // Tipo de confirmação por email
      if (this.state.companyData.chanelConfirm === 'EMAIL') {
        let dataSendEmailInValidation = {
          id: this.state.companyData.id,
          type: 'SALESMAN'
        };

        axios.post(configBase.api + 'Companies/SendEmailOnValidation?access_token='+localStorage.getItem('planos_t'), dataSendEmailInValidation)
        .then((response) => {
          if (response.data.error !== true) {
            let state = this.state;
            state.confirm = true;
            state.errorCheck = false;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();

            // Caso a empresa não estiver confirmado
            if (response.data.company.companyConfirm === null)
              this.snackbarSuccessOpen('Aguardando confirmação da empresa');
            else
              this.snackbarSuccessOpen('Proposta enviada para análise com sucesso');              

            this.getDetails(this.state.companyData.id);
          }
          else {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Problema encontrado ao enviar proposta para análise', this.state.companyData);
          }
        })
        .catch(() => {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.setError('Problema encontrado ao enviar proposta para análise', this.state.companyData);
        });
      }
      else {
        let dataPost = {
          status: "EM VALIDAÇÃO",
          analyzing: false
        };

        axios.post(configBase.api + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}&access_token='+localStorage.getItem('planos_t'), dataPost)
        .then(() => {
          let state = this.state;
          state.confirm = true;
          state.errorCheck = false;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.snackbarSuccessOpen('Proposta enviada para análise com sucesso');
          this.getDetails(this.state.companyData.id);
        })
        .catch(() => {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.setError('Problema encontrado ao enviar proposta para análise', this.state.companyData);
        });
      }
    }
    else {
      let dataPost = {
        status: "EM VALIDAÇÃO",
        analyzing: false
      };

      axios.post(configBase.api + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}&access_token='+localStorage.getItem('planos_t'), dataPost)
      .then(() => {
        let state = this.state;
        state.confirm = true;
        state.errorCheck = false;
        state.modalConfirmButtonLoading = false;
        this.handleConfirmClose();
        this.snackbarSuccessOpen('Proposta enviada para análise com sucesso');
        this.getDetails(this.state.companyData.id);
      })
      .catch(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setError('Problema encontrado ao enviar proposta para análise', this.state.companyData);
      });
    }
  }

  // Usado também em admin/back/common/models/sales.js
  removeAccents(strAccents) {
    strAccents = strAccents.split('');

		var strAccentsOut = [];
		var strAccentsLen = strAccents.length;
		var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";

		for (var y = 0; y < strAccentsLen; y++) {
			if (accents.indexOf(strAccents[y]) !== -1) {
				strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
			} else
				strAccentsOut[y] = strAccents[y];
    }

		strAccentsOut = strAccentsOut.join('');
		return strAccentsOut;
	}

  verifySus() {
    // Verifica cartão do sus dos dependentes
    let holder = this.state.companyData.holder
    let dependents = this.state.companyData.dependents;
    let error = false;

    if (holder.susNumber === null || holder.susNumber === undefined || holder.susNumber.length === 0)
      error = true;

    for (let i = 0; i < dependents.length; i++) {
      if (dependents[i].susNumber === null || dependents[i].susNumber === undefined || dependents[i].susNumber.length === 0) {
        error = true;
        break;
      }
    }

    if (error === true) {
      let state = this.state;
      state.msgSus = 'Existem beneficiários com cartão do SUS não informado. Deseja continuar?';
      state.modalConfirmActionType = 'activate';
      this.setState(state);
    }
    else
      this.sendS4();
  }

  beforeSendS4() {
    // Verifica a existência da planilha de usuário
    let errorUserTable = false;

    // Verifica se foi anexado a planilha de usuário
    if (this.state.companyData.imagesDoc.usersTable === undefined || this.state.companyData.imagesDoc.usersTable.length === 0)
      errorUserTable = true;

    if (errorUserTable === true) {
      let state = this.state;
      state.msgUserTable = '* A planilha com os dados dos beneficiários não está anexada';
      state.msgContinue = true;

      state.modalConfirmActionType = 'activate';
      this.setState(state);
    }
    
    if (errorUserTable === false)
      this.sendS4();
  }

  sendS4() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let url = configBase.api + 'APIS4s/NovaEmpresa?access_token='+localStorage.getItem('planos_t');
    let dataSend = {
      company: this.state.companyData.id
    };

    axios.post(url, dataSend)
    .then((response) => {
      if (response.data.error.codigo) {
        if (response.data.error.codigo !== 1) {
          if (response.data.error.mensagem) {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError(response.data.error.mensagem);
          }
          else {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Problema encontrado ao salvar empresa');
          }
        }
        else {
          let dataSendEmail = {
            id: this.state.companyData.id
          };
  
          this.snackbarSuccessOpen('Proposta ativada com sucesso. Enviando email para a empresa...');
  
          axios.post(configBase.api + 'Companies/SendEmailActive?access_token='+localStorage.getItem('planos_t'), dataSendEmail)
          .then(() => {
            this.snackbarSuccessClose();
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.snackbarSuccessOpen('Proposta ativada com sucesso e email enviado');
            this.getDetails(this.state.companyData.id);
          })
          .catch(() => {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Porposta ativada, porém, houve um problema no envio de email para a empresa', this.state.companyData);
          });
        }
      }
      else {
        let dataSendEmail = {
          id: this.state.companyData.id
        };

        this.snackbarSuccessOpen('Proposta ativada com sucesso. Enviando email para a empresa...');

        axios.post(configBase.api + 'Companies/SendEmailActive?access_token='+localStorage.getItem('planos_t'), dataSendEmail)
        .then(() => {
          this.snackbarSuccessClose();
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.snackbarSuccessOpen('Proposta ativada com sucesso e email enviado');
          this.getDetails(this.state.companyData.id);
        })
        .catch(() => {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.setError('Porposta ativada, porém, houve um problema no envio de email para a empresa', this.state.companyData);
        });
      }
    })
    .catch((error) => {
      if (error.response.data && error.response.data.error && error.response.data.error.error) {
        if (error.response.data.error.error.codigo === 3) {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.setError('Problema encontrado: '+ error.response.data.error.error.mensagem);
        }
        else if (error.response.data.error.error.codigo === 1) {
          let dataSendEmail = {
            id: this.state.companyData.id
          };
  
          this.snackbarSuccessOpen('Proposta ativada com sucesso. Enviando email para a empresa...');
  
          axios.post(configBase.api + 'Companies/SendEmailActive?access_token='+localStorage.getItem('planos_t'), dataSendEmail)
          .then(() => {
            this.snackbarSuccessClose();
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.snackbarSuccessOpen('Proposta ativada com sucesso e email enviado');
            this.getDetails(this.state.companyData.id);
          })
          .catch(() => {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Porposta ativada, porém, houve um problema no envio de email para a empresa', this.state.companyData);
          });
        }
        else {
          if (error.response.data.error.error.mensagem && error.response.data.error.error.mensagem.length > 0) {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Problema encontrado: '+ error.response.data.error.error.mensagem);
          }
          else {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Problema encontrado ao confirmar proposta');
          }
        }
      }
      else {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.handleConfirmClose();
        this.setError('Problema encontrado ao confirmar proposta');
      }
    });
  }

  sendEmail() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let data = {
      id: this.state.companyData.id
    };

    axios.post(configBase.api + 'Companies/SendEmailCompanyCreated?access_token='+localStorage.getItem('planos_t'), data)
    .then((result) => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;

      if (result.data.error !== undefined && result.data.error === true) {
        this.handleConfirmClose();
        this.setError('Houve um problema no envio de email a empresa', this.state.detailsData);
      }
      else {
        this.handleConfirmClose();
        this.snackbarSuccessOpen('E-mail reenviado com sucesso');
        this.getDetails(this.state.companyData.id.toString());
      }
    })
    .catch(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.handleConfirmClose();
      this.setError('Houve um problema no envio de email a empresa', this.state.detailsData);
    });
  }

  baixarBoleto(event) {
    event.preventDefault();
    let state = this.state;
    state.showLoadindDowloadPdf = true;
    this.setState(state);

    /* axios.get(configBase.api + 'Pagamentos/token')
    .then((result) => { */
      axios.get('https://p4x.srv.br/api/v1.0/boletos/'+this.state.companyData.boletoId+'/imprimir', {
        responseType: 'arraybuffer',
        headers: {
          //Authorization: 'Bearer ' + result.token,
          'Content-type': 'application/pdf'
        }
      })
      .then((response) => {
        let file = new Blob([response.data], {type: 'application/pdf'});
        let fileURL = URL.createObjectURL(file);
        let link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'boleto.pdf');
        document.body.appendChild(link);
        link.click();

        let state = this.state;
        state.showLoadindDowloadPdf = false;
        this.setState(state);
      })
      .catch(function (error) {
        console.log('1- ', error);
        this.setError('Problema encontrado gerar boleto', this.state.companyData);
      }.bind(this));
    /* })
    .catch(function () {
      this.setError('Problema encontrado gerar boleto', this.state.companyData);
    }.bind(this)); */
  }

  editHolder(index) {
    let state = this.state;
    state.holderIndex = index;
    this.setState(state);

    this.modalAddHolderFn();
  }

  modalAddHolderFn() {
    let state = this.state;
    state.modalAddHolder = !state.modalAddHolder;
    this.setState(state);
  }

  updateFieldsModalForm(type, event) {
    /*
     * @type - Pode ser 'holder' ou 'dependent'
    */

    let state = this.state;

    if (type === 'holder') {
      state.companyData.dependents[state.holderIndex][event.target.name].value = event.target.value;
      state.companyData.dependents[state.holderIndex][event.target.name].error = '';

      // Apenas letras
      if (state.companyData.dependents[state.holderIndex][event.target.name].type === 'text')
        this.validateLetters(event.target.value, event.target.name, 'holder');
      // Apenas Números
      else if (state.companyData.dependents[state.holderIndex][event.target.name].type === 'number')
        this.validateNumber(event.target.value, event.target.name, 'holder');
    }
    else {
      state.companyData.dependents[state.holderIndex].dependents[state.dependentIndex][event.target.name].value = event.target.value;
      state.companyData.dependents[state.holderIndex].dependents[state.dependentIndex][event.target.name].error = '';

      // Apenas letras
      if (state.companyData.dependents[state.holderIndex].dependents[state.dependentIndex][event.target.name].type === 'text')
        this.validateLetters(event.target.value, event.target.name, 'dependent');
      // Apenas Números
      else if (state.companyData.dependents[state.holderIndex].dependents[state.dependentIndex][event.target.name].type === 'number')
        this.validateNumber(event.target.value, event.target.name, 'dependent');
    }

    this.setState(state);
  }

  editDependent(indexDep, indexHol) {
    let state = this.state;
    state.holderIndex = indexHol;
    state.dependentIndex = indexDep;
    this.setState(state);

    this.modalAddDependentOpen(indexHol, indexDep);
  }

  modalAddDependentOpen(indexHold, indexDep=null) {
    let state = this.state;
    state.modalAddDependent = true;
    state.holderIndex = indexHold;
    state.dependentIndex = indexDep;
    this.setState(state);
  }

  modalAddDependentClose() {
    let state = this.state;
    state.modalAddDependent = false;
    this.setState(state);
  }

  stateToResume() {
    if (this.state.companyData.state) {
      for (let i = 0; i < this.state.stateList.length; i++) {
        if (this.state.companyData.state.toString() === this.state.stateList[i].Id.toString()) {
          return this.state.stateList[i].Sigla;
        }
      }
    }
  }

  cityToResume()  {
    if (this.state.companyData.city) {
      for (let i = 0; i < this.state.cityList.length; i++) {
        if (this.state.companyData.city.toString() === this.state.cityList[i].Id.toString()) {
          return this.state.cityList[i].Nome;
        }
      }
    }
  }

  addressTypeToResume() {
    if (this.state.companyData.addressType) {
      for (let i = 0; i < this.state.addressTypeList.length; i++) {
        if (this.state.companyData.addressType.toString() === this.state.addressTypeList[i].Id.toString()) {
          return this.state.addressTypeList[i].Nome;
        }
      }
    }
  }

  districtToResume() {
    if (this.state.companyData.district) {
      for (let i = 0; i < this.state.districtList.length; i++) {
        if (this.state.companyData.district.toString() === this.state.districtList[i].Id.toString()) {
          return this.state.districtList[i].Nome;
        }
      }
    }
    else {
      return false;
    }
  }

  formatacaoData () {
    if (this.state.companyData.companyConfirm) {
      let dataBanco = this.state.companyData.companyConfirm.substr(0, 10).split('-')
      let horaBanco = this.state.companyData.companyConfirm.substr(11, 8)

      let dataEHora = dataBanco[2] + '/' + dataBanco[1] + '/' + dataBanco[0] + ' ' + horaBanco

      return dataEHora
    }
    else
      return '';
  }

  detalhes() {
    return (
      <div id="detalhes">
        {/* Para as pendências */
          this.state.companyData.status === 'PENDENTE' ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Proposta Indeferida
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Alert severity="error">{this.state.companyData.pendency}</Alert>
              </Grid>
            </Grid>
          </div>
        </Paper>
          ) : (
            this.state.companyData.status === 'CANCELADO' ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Proposta Cancelada
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {
                  this.state.companyData.protocoloCancelamento ? (
                <Alert severity="error">
                  {this.state.companyData.cancellation} - Protocolo - {this.state.companyData.protocoloCancelamento}
                </Alert>
                  ) : (
                <Alert severity="error">{this.state.companyData.cancellation}</Alert>
                  )
                }
              </Grid>
            </Grid>
          </div>
        </Paper>
            ) : ('')
          )
        }


        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Planos Contratados
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
          {this.state.companyData.precoPlano.map((item, index) =>
            <div key={index}>
              <Grid container spacing={2} key={index}>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <TextField
                    disabled
                    fullWidth
                    label="Plano"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.plano}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={2}>
                  <CurrencyTextField
                    label="Valor Titular"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={item.valorTitular.replace(',', '.')}
                    name="valuePlan"
                    currencySymbol="R$"
                    outputFormat="string"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={2}>
                  <CurrencyTextField
                    label="Valor Dependente"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={item.valorDependente.replace(',', '.')}
                    name="valuePlan"
                    currencySymbol="R$"
                    outputFormat="string"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={2}>
                  <CurrencyTextField
                    label="Valor Agregado"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={item.valorAgregado.replace(',', '.')}
                    name="valuePlan"
                    currencySymbol="R$"
                    outputFormat="string"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    disabled={true}
                  />
                </Grid>
              </Grid>
              {
                index < (this.state.companyData.precoPlano.length -1) && (
                <div style={{marginTop: 15, marginBottom: 15}}>
                  <Divider />
                </div>
                )
              }

            </div>
          )}
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Corretora e Vendedor
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Corretora"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.companyData.broker}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Vendedor"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.companyData.salesman}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  disabled
                  fullWidth
                  label="Código S4E"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.companyData.salesmanCode}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Informações do Pagamento
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <CurrencyTextField
                  label="Valor Total"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={this.state.companyData.responsibility.replace(',', '.')}
                  name="valuePlan"
                  currencySymbol="R$"
                  outputFormat="string"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  disabled
                  fullWidth
                  label="Forma de Pagamento"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={
                    this.state.companyData.boletoId ? ("BOLETO BANCÁRIO") : (
                      this.state.companyData.reteveAdesao === true ? ("ADESÃO RETIDA PELO VENDEDOR") : (
                        "NÃO ENCONTRADO"
                      )
                    )
                  }
                />
              </Grid>

              {
                this.state.companyData.boletoId && (
                  this.state.companyData.vencimentoBoleto && (
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  disabled
                  fullWidth
                  label="Vencimento"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.companyData.vencimentoBoleto}
                />
              </Grid>
                  )
                )
              }

              {
                this.state.companyData.boletoId && (
                  this.state.companyData.situacaoBoleto && (
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  disabled
                  fullWidth
                  label="Situação"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.companyData.situacaoBoleto}
                />
              </Grid>
                  )
                )
              }

              {
                this.state.companyData.boletoId && (
                  this.state.showLoadindDowloadPdf === true ? (
                <Grid item xs={12} sm={12} md={4} lg={4}><CircularProgress /></Grid>
                    ) : (
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Link
                    href="#"
                    onClick={this.baixarBoleto.bind(this)}
                    style={{textDecoration: 'underline'}}
                  >
                    Vizualizar boleto
                  </Link>
                </Grid>
                  )
                )
              }
            </Grid>

          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Confirmação da Adesão
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper" id="i_confirmCheck">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
              {
                this.state.companyConfirm.length > 0 ? (
                <MuiAlert severity="info" variant="filled" elevation={0}>
                  {this.state.companyConfirm}
                </MuiAlert>
                ) : (
                <MuiAlert severity="info" variant="filled" elevation={0}>
                  Empresa já realizou a confirmação da adesão
                </MuiAlert>
                )
              }
              </Grid>
            </Grid>
          </div>
        </Paper>

      </div>
    );
  }

  responsavelFinanceiro() {

    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Informações da Empresa
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <InputMask
                  mask="99.999.999/9999-99"
                  maskChar=" "
                  //disabled={this.state.disabledCNPJ}
                  value={this.state.companyData.cnpj}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'cnpj')}
                >
                  {() => <TextField
                    fullWidth
                    label="CNPJ"
                    variant="outlined"
                    size="small"
                    name="cnpj"
                    //disabled={this.state.disabledCNPJ}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={7} lg={7}>
                <TextField
                  fullWidth
                  label="Email"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="infoEmailInvoice"
                  value={this.state.companyData.infoEmailInvoice}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'infoEmailInvoice')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="(99) 9999-9999"
                  maskChar=" "
                  value={this.state.companyData.homePhone}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'homePhone')}
                >
                  {() => <TextField
                    fullWidth
                    label="Tel. Fixo"
                    variant="outlined"
                    size="small"
                    name="homePhone"
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.companyData.cellPhone}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'cellPhone')}
                >
                  {() => <TextField
                    fullWidth
                    label="Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone"
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.companyData.cellPhone2}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'cellPhone2')}
                >
                  {() => <TextField
                    fullWidth
                    label="2º Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone2"
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Nome Fantasia"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="fantasyName"
                  value={this.state.companyData.fantasyName}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'fantasyName')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Razão Social"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="businessName"
                  value={this.state.companyData.businessName}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'businessName')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={2}>
                <InputMask
                  mask="99.999-999"
                  maskChar=" "
                  value={this.state.companyData.cep}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.getAddress.bind(this)}
                >
                  {() => <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="cep"
                    label="CEP"
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Logradouro"
                  variant="outlined"
                  size="small"
                  name="addressType"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.addressType}
                  disabled={true}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'addressType')}
                >
                {this.state.addressTypeList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingAddressType === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }

              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={7} className="containerButton">
                <TextField
                  fullWidth
                  label="Endereço"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="address"
                  value={this.state.companyData.address}
                  disabled={true}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'address')}
                />
                {
                  this.state.disabledLoadingAddress === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={1} className="containerButton">
                <TextField
                  id="fm_addressNumber"
                  fullWidth
                  label="Nº"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="addressNumber"
                  value={this.state.companyData.addressNumber}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'addressNumber')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                <TextField
                  fullWidth
                  label="Complemento"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="addressComplement"
                  value={this.state.companyData.addressComplement}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'addressComplement')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={1} lg={1} className="containerButton">
                <TextField
                  fullWidth
                  select
                  label="UF"
                  variant="outlined"
                  size="small"
                  name="state"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.state}
                  disabled={true}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'state')}
                >
                {this.state.stateList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Sigla}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingState === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Município"
                  variant="outlined"
                  size="small"
                  name="city"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.city}
                  disabled={true}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'city')}
                >
                {this.state.cityList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingCity === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Bairro"
                  variant="outlined"
                  size="small"
                  name="district"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.district}
                  disabled={true}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'district')}
                >
                {this.state.districtList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingDistrict === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>

            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Representante Legal
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="legalResponsible"
                  value={this.state.companyData.legalResponsible}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'legalResponsible')}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.companyData.legalResponsibleCpf}
                  onChange={this.updateField.bind(this)}
                  onBlur={this.updateDB.bind(this, 'legalResponsibleCpf')}
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="legalResponsibleCpf"
                  />}
                </InputMask>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );
  }

  beneficiarios() {
    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Titulares e Dependentes
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            {/* ############# CSS PARA DATATABLE ############# */}
            <link
              rel="stylesheet" type="text/css"
              href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
            />
            <link
              rel="stylesheet" type="text/css"
              href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
            />
            {/* ############# CSS PARA DATATABLE ############# */}

            <table id="table_id" className="mdl-data-table display nowrap" style={{width:'100%'}}>
              <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                <tr style={this.styles.theadTr}>
                  <th style={this.styles.theadTh} className='no-sort'>
                    <Typography variant="button" display="block" gutterBottom
                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                    >
                      TIPO
                    </Typography>
                  </th>
                  <th style={this.styles.theadTh}>
                    <Typography variant="button" display="block" gutterBottom
                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                      >
                      NOME
                    </Typography>
                  </th>
                  <th style={this.styles.theadTh} className='no-sort'>
                    <Typography variant="button" display="block" gutterBottom
                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                      >
                      CPF
                    </Typography>
                  </th>
                  <th style={this.styles.theadTh} className='no-sort'>
                    <Typography variant="button" display="block" gutterBottom
                      style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                      >
                      AÇÃO
                    </Typography>
                  </th>
                </tr>
              </thead>

              {this.state.companyData.dependents.map((item, index) =>
                <tbody key={index}>
                  <tr
                    className="row_table"
                    style={this.styles.theadTh2}
                  >
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                      >
                        <span
                          style={{
                            padding: '5px 7px', border: '1px solid '+configBase.corPrincipal,
                            borderRadius: 5, color: configBase.corPrincipal
                          }}
                        >
                          TITULAR
                        </span>
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                      >
                        {item.firstName}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                      >
                        {item.cpf}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <div style={{textAlign: 'left'}}>
                        <IconButton
                          aria-label="delete"
                          style={{padding: '8px 8px'}}
                          onClick={this.editHolder.bind(this, index)}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                  {item.dependents.map((item2, index2) =>
                  <tr
                    key={index2}
                    className="row_table"
                    style={this.styles.theadTh}
                  >
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                      >
                        <span
                          style={{
                            padding: '5px 7px', border: '1px solid #757575',
                            borderRadius: 5, color: '#757575'}}
                        >
                          DEP
                        </span>
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 40}}
                      >
                        {item2.firstName}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                      >
                        {item2.cpf}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <div style={{textAlign: 'left'}}>
                        <IconButton
                          aria-label="delete"
                          style={{padding: '8px 8px'}}
                          onClick={this.editDependent.bind(this, index2, index)}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>

          {/* <div className="paper">
            {
              this.state.companyData.imagesDoc.usersTable.length > 0 ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign: 'center', marginBottom: 20}}>
                <Typography variant="overline" display="inline" gutterBottom>
                  BAIXAR PLANILHA COM RELAÇÃO DOS BENEFICIÁRIOS
                </Typography>
                <div>
                  <a
                    href={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.usersTable}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{color: configBase.corPrincipal}}
                  >
                    <CloudDownloadIcon className="iconLarge" fontSize="large"/>
                  </a>
                </div>
              </Grid>
            </Grid>
              ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign: 'center', marginBottom: 20}}>
                <Typography variant="overline" display="inline" gutterBottom>
                  BAIXAR PLANILHA COM RELAÇÃO DOS BENEFICIÁRIOS
                </Typography>
                <div>
                  <CloudOffIcon className="iconLarge" fontSize="large"/>
                </div>
                <Typography variant="caption" display="block" gutterBottom>
                  PLANILHA COM RELAÇÃO DOS BENEFICIÁRIOS NÃO INSERIDA
                </Typography>
              </Grid>
            </Grid>
              )
            }

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Quant. Titulares"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="amountHolder"
                  value={this.state.companyData.amountHolder}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <CurrencyTextField
                  label="Valor por Titular"
                  fullWidth
                  variant="outlined"
                  size="small"
                  //value={this.state.companyData.valuePlanHolder.replace(',', '.')}
                  name="valuePlanHolder"
                  currencySymbol="R$"
                  outputFormat="string"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Quant. Dependentes"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="amountDependent"
                  value={this.state.companyData.amountDependent}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <CurrencyTextField
                  label="Valor por Dependente"
                  fullWidth
                  variant="outlined"
                  size="small"
                  //value={this.state.companyData.valuePlanDependent.replace(',', '.')}
                  name="valuePlanDependent"
                  currencySymbol="R$"
                  outputFormat="string"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  disabled={true}
                />
              </Grid>
            </Grid>
          </div> */}
        </Paper>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalAddHolder}
          onClose={this.modalAddHolderFn.bind(this)}
          aria-labelledby="i_addHolder"
        >
          <DialogTitle id="i_addHolder">{"Visualizar Titular"}</DialogTitle>

          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={this.state.companyData.dependents[this.state.holderIndex].firstName}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.companyData.dependents[this.state.holderIndex].cpf}
                  disabled
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="cpf"
                    disabled
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="E-mail"
                  type="email"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={this.state.companyData.dependents[this.state.holderIndex].email}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.companyData.dependents[this.state.holderIndex].cellPhone}
                  disabled
                >
                  {() => <TextField
                    fullWidth
                    label="Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone"
                    disabled
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="RG"
                  type="tel"
                  variant="outlined"
                  size="small"
                  name="rg"
                  value={this.state.companyData.dependents[this.state.holderIndex].rg}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Org. Emissor"
                  variant="outlined"
                  size="small"
                  name="rgEmitter"
                  value={this.state.companyData.dependents[this.state.holderIndex].rgEmitter}
                  inputProps={{maxLength:10}}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Nascimento"
                    format="dd/MM/yyyy"
                    size="small"
                    name="dateOfBirth"
                    value={new Date(this.state.companyData.dependents[this.state.holderIndex].dateOfBirth+'T00:00:00')}
                    disabled
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  select
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  name="gender"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.dependents[this.state.holderIndex].gender}
                  disabled
                >
                  <option value="null">Selecionar</option>
                  <option value="0">Feminino</option>
                  <option value="1">Masculino</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Cartão do SUS"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="susNumber"
                  value={this.state.companyData.dependents[this.state.holderIndex].susNumber}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.companyData.dependents[this.state.holderIndex].motherName}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Plano"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="plans"
                  value={this.state.companyData.dependents[this.state.holderIndex].plans}
                  disabled
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.modalAddHolderFn.bind(this)}
            >
              FECHAR
            </Button>
          </DialogActions>

        </Dialog>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalAddDependent}
          onClose={this.modalAddDependentClose.bind(this)}
          aria-labelledby="i_addDependent"
        >
          <DialogTitle id="i_addDependent">{"Visualizar Dependente"}</DialogTitle>

          <DialogContent>
            {
              this.state.companyData.dependents[this.state.holderIndex].dependents.length > 0 && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].firstName}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].cpf}
                  disabled
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="cpf"
                    disabled
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="E-mail"
                  type="email"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].email}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].cellPhone}
                  disabled
                >
                  {() => <TextField
                    fullWidth
                    label="Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone"
                    disabled
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="RG"
                  type="tel"
                  variant="outlined"
                  size="small"
                  name="rg"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].rg}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Org. Emissor"
                  variant="outlined"
                  size="small"
                  name="rgEmitter"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].rgEmitter}
                  inputProps={{maxLength:10}}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Nascimento"
                    format="dd/MM/yyyy"
                    size="small"
                    name="dateOfBirth"
                    value={new Date(this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].dateOfBirth+'T00:00:00')}
                    disabled
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  select
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  name="gender"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].gender}
                  disabled
                >
                  <option value="null">Selecionar</option>
                  <option value="0">Feminino</option>
                  <option value="1">Masculino</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  select
                  label="Parentesco"
                  variant="outlined"
                  size="small"
                  name="parentage"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].parentage}
                  disabled
                >
                  <option value="null">Selecionar</option>
                  <option value="CÔNJUGE">Cônjuge</option>
                  <option value="FILHO">Filho</option>
                  <option value="PAI/MÃE">Pai/Mãe</option>
                  <option value="ENTEADO">Enteado</option>
                  <option value="OUTRO">Outro</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Cartão do SUS"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="susNumber"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].susNumber}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].motherName}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.companyData.dependents[this.state.holderIndex].dependents[this.state.dependentIndex].plans}
                  disabled
                />
              </Grid>
            </Grid>
              )
            }
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.modalAddDependentClose.bind(this)}
            >
              FECHAR
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  documentos() {

    return (
      <div>
        <div className="paper">
          <Grid container spacing={2}>
{/* ################### Imagem RG ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Documento Repres. Legal (Frente e Verso)"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg, 'Documento Repres. Legal')}
                >
                  {
                    this.state.companyData.imagesDoc.rg.length > 0 ? (
                      this.state.companyData.imagesDoc.rg.substr(this.state.companyData.imagesDoc.rg.length - 3, this.state.companyData.imagesDoc.rg.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Documento Repres. Legal (Frente e Verso)"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.rg}
                    title="Documento Repres. Legal (Frente e Verso)"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.rg.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg, 'Documento Repres. Legal')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem RG (verso) ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Documento Dependentes (Frente e Verso)"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg2, 'Documento Dependentes')}
                >
                  {
                    this.state.companyData.imagesDoc.rg2.length > 0 ? (
                      this.state.companyData.imagesDoc.rg2.substr(this.state.companyData.imagesDoc.rg2.length - 3, this.state.companyData.imagesDoc.rg2.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Documento Dependentes (Frente e Verso)"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.rg2}
                    title="Documento Dependentes (Frente e Verso)"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.rg2.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg2, 'Arquivo do Verso do RG')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem CPF ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Documento Dependentes (Frente e Verso)"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.cpf, 'Documento Dependentes')}
                >
                  {
                    this.state.companyData.imagesDoc.cpf.length > 0 ? (
                      this.state.companyData.imagesDoc.cpf.substr(this.state.companyData.imagesDoc.cpf.length - 3, this.state.companyData.imagesDoc.cpf.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Documento Dependentes (Frente e Verso)"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.cpf}
                    title="Documento Dependentes (Frente e Verso)"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.cpf.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.cpf, 'Documento Dependentes')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                   <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem CNPJ ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Comprovante de Inscrição Cadastral do CNPJ"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.cnpj, 'Comprovante de Inscrição Cadastral do CNPJ')}
                >
                  {
                    this.state.companyData.imagesDoc.cnpj.length > 0 ? (
                      this.state.companyData.imagesDoc.cnpj.substr(this.state.companyData.imagesDoc.cnpj.length - 3, this.state.companyData.imagesDoc.cnpj.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Comprovante de Inscrição Cadastral do CNPJ"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.cnpj}
                    title="Comprovante de Inscrição Cadastral do CNPJ"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.cnpj.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.cnpj, 'Comprovante de Inscrição Cadastral do CNPJ')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cnpj')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                   <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cnpj')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem Comp. de  Residência ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Comprovante de Residência"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.address, 'Arquivo do Comp. de  Residência')}
                >
                  {
                    this.state.companyData.imagesDoc.address.length > 0 ? (
                      this.state.companyData.imagesDoc.address.substr(this.state.companyData.imagesDoc.address.length - 3, this.state.companyData.imagesDoc.address.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Comprovante de Residência"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.address}
                    title="Comprovante de Residência"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.address.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.address, 'Arquivo do Comp. de  Residência')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'address')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem Ato Constitutivo ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Ato Constitutivo (Certificado MEI)"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.physicalContract1, 'Ato Constitutivo (Certificado MEI)')}
                >
                  {
                    this.state.companyData.imagesDoc.physicalContract1.length > 0 ? (
                      this.state.companyData.imagesDoc.physicalContract1.substr(this.state.companyData.imagesDoc.physicalContract1.length - 3, this.state.companyData.imagesDoc.physicalContract1.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Ato Constitutivo (Certificado MEI)"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.physicalContract1}
                    title="Ato Constitutivo (Certificado MEI)"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.physicalContract1.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.physicalContract1, 'Ato Constitutivo (Certificado MEI)')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract1')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract1')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem  Documentos Agregados ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Documentos Agregados"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.physicalContract2, 'Documentos Agregados')}
                >
                  {
                    this.state.companyData.imagesDoc.physicalContract2.length > 0 ? (
                      this.state.companyData.imagesDoc.physicalContract2.substr(this.state.companyData.imagesDoc.physicalContract2.length - 3, this.state.companyData.imagesDoc.physicalContract2.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Documentos Agregados"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.physicalContract2}
                    title="Documentos Agregados"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.physicalContract2.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.physicalContract2, 'Documentos Agregados')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract2')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'physicalContract2')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem Outro ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  className="cardHeaderHeightMin"
                  title="Outro"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.others, 'Arquivo Outro')}
                >
                  {
                    this.state.companyData.imagesDoc.others.length > 0 ? (
                      this.state.companyData.imagesDoc.others.substr(this.state.companyData.imagesDoc.others.length - 3, this.state.companyData.imagesDoc.others.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Outro"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.companyData.imagesDoc.others}
                    title="Outro"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.companyData.imagesDoc.others.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.others, 'Arquivo Outro')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
          </Grid>
        </div>


        <DropzoneDialog
          dialogTitle="Upload do arquivo"
          cancelButtonText="CANCELAR"
          submitButtonText="OK"
          getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
          open={this.state.dropzoneDialog}
          onSave={this.fileToBase64.bind(this)}
          acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', 'application/pdf']}
          showPreviews={true}
          maxFileSize={5000000}
          onClose={this.dropzoneDialogClose.bind(this)}
          filesLimit={1}
          dropzoneText="Clique ou arraste e solte um arquivo aqui"
          previewText="Pré-visualização"
          showAlerts={false}
        />
      </div>
    );
  }
  

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="resumoProposta" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  RESUMO DA PROPOSTA{this.state.titlePage}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={8} className="barraBotao">

                {
                  this.districtToResume() && (
                <div className="botoesDeEnvio">
                  <ReactToPrint                  
                    trigger={() =>
                      <div style={{marginRight: 10}}>
                        <Button 
                          style={{ marginRight: 5, backgroundColor: '#636d77', color: '#fff'}}
                          fullWidth={true}
                          variant="contained"
                          size="small"
                          startIcon={<PrintIcon />}
                          color="default"
                          ref={this.printTrigger}
                        >
                          IMPRIMIR
                        </Button>
                      </div>
                    }
                    content={() => this.printContentFinal}
                  />
                </div>
                  )
                }

              {
                this.state.showActionCancel === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: "#dc004e", color: "#fff", marginRight: 5}}
                    startIcon={<ClearIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta ficará como cancelada. Deseja continuar?', 'cancel', 'SIM')}
                  >
                    CANCELAR PROPOSTA
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionPendency === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{backgroundColor: "#afb42b", color: "#fff", marginRight: 5}}
                    startIcon={<CancelScheduleSendIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta ficará como indeferida. Deseja continuar?', 'pending', 'SIM')}
                  >
                    INDEFERIR PROPOSTA
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionInValidation === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria, marginRight: 5}}
                    startIcon={<SendIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'Confirmo que a proposta está pronta para ser analizada. Deseja continuar?', 'analyze', 'SIM')}
                  >
                    ENVIAR PARA ANÁLISE
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionS4 === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<AssignmentTurnedInIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta será ativada. Deseja continuar?', 'sus', 'SIM')}
                  >
                    ATIVAR PROPOSTA
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionEmail === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<MailOutlineIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'Deseja reenviar e-mail de confirmação para a empresa?', 'email', 'SIM')}
                    disabled={this.state.disableButtons}
                  >
                    REENVIAR E-MAIL
                  </Button>
                </div>
                ) : ('')
              }
              </Grid>
            </Grid>

          </Paper>

          <div id="resumoPropostaConteudo" className="contentepanel">
          {
          this.state.companyData === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  {this.state.companyDataLoadingMsg}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.companyData === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar dados da proposta</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.companyData === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Esta proposta não foi encontrada</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="resumoPropostaForm">
              <ScrollableTabsButtonAuto contentTabs={
                [
                  this.detalhes(),
                  this.responsavelFinanceiro(),
                  this.beneficiarios(),
                  this.documentos()
                ]
              } />
            </div>
              )
              )
            )
          }

            <div>
              {/* Página de Impressão */}
              {
                this.state.imprimir === true && (
              <div id="printOnly" ref={el => (this.printContentFinal = el)} style={{display: "none"}}>
                <Paper elevation={0} className="paperForm">
                  <div className="paper">
                    <div>
                      <img id="imagemId" alt="logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
                    </div>

                    <div>                    
                      <Typography style={{textAlign: 'center', color: configBase.corPrincipal}} variant="h6" gutterBottom className="titlePaperForm">
                        RESUMO DA PROPOSTA Nº {this.state.companyData.proposalNumber}                                         
                      </Typography>                          
                    </div>
                  </div>

                  <div>
                    <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                      <Typography variant="overline" gutterBottom className="titlePaperForm">
                        Informações da Empresa
                      </Typography>
                    </div>
                    <div className="formPrintFields">
                      <Grid container spacing={2} className="respFinanceiro">
                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>CNPJ:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.cnpj}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={6} sm={6} md={6} lg={6} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Email:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.infoEmailInvoice}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Tel. Fixo:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.homePhone}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Celular:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.cellPhone}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>2º Celular:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.cellPhone2}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={5} sm={5} md={5} lg={5} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nome Fantasia:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.fantasyName}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={5} sm={5} md={5} lg={5} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Razão Social:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.businessName}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>CEP:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.cep}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Logradouro:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.addressTypeToResume()}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={7} sm={7} md={7} lg={7} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Endereço:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.address}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={1} sm={1} md={1} lg={1} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Nº:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.addressNumber}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={4} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Complemento:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.state.companyData.addressComplement}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={1} sm={1} md={1} lg={1} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>UF:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.stateToResume()}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={4} sm={4} md={4} lg={4} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Município:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.cityToResume()}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={3} sm={3} md={3} lg={3} className="atribRespFinanceiro">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Bairro:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {this.districtToResume()}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </div>

                  <div className="page-break" />
                  <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                    <Typography variant="overline" gutterBottom className="titlePaperForm">
                      Titulares e Dependentes
                    </Typography>
                  </div>

                  <div className="formPrintFields">
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <div className="page-break" />
                        {
                          this.state.companyData.dependents && (
                        <div>
                          <table
                            id="table_id"
                            className="mdl-data-table display nowrap"
                            style={{width:'100%', marginTop: 8, borderCollapse: 'collapse', borderSpacing: 0}}
                          >
                            <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                              <tr style={this.styles.theadTr}>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, cursor: 'default', textAlign: 'left'}}
                                  >
                                    TIPO
                                  </Typography>
                                </th>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                    >
                                    NOME
                                  </Typography>
                                </th>
                                <th style={{height: 30, paddingLeft: 10}}>
                                  <Typography variant="button" display="block" gutterBottom
                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12, textAlign: 'left'}}
                                    >
                                    CPF
                                  </Typography>
                                </th>
                              </tr>
                            </thead>
              
                            {this.state.companyData.dependents.map((item, index) =>
                              <tbody key={index} style={{width: '100%'}}>
                                <tr
                                  className="row_table"
                                  style={this.styles.theadTh2}
                                >
                                  <td style={{padding: 0, height: 40}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      <span
                                        style={{
                                          padding: '5px 7px', border: '1px solid '+configBase.corPrincipal,
                                          borderRadius: 5, color: configBase.corPrincipal
                                        }}
                                      >
                                        TITULAR
                                      </span>
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 40}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {item.firstName}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 40}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {item.cpf}
                                    </Typography>
                                  </td>
                                </tr>
                                {item.dependents.map((item2, index2) =>
                                <tr
                                  key={index2}
                                  className="row_table"
                                  style={this.styles.theadTh}
                                >
                                  <td style={{padding: 0, height: 40}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'right', paddingLeft: 10}}
                                    >
                                      <span
                                        style={{
                                          padding: '5px 7px', border: '1px solid #757575',
                                          borderRadius: 5, color: '#757575'}}
                                      >
                                        DEP
                                      </span>
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 40}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 40}}
                                    >
                                      {item2.firstName}
                                    </Typography>
                                  </td>
                                  <td style={{padding: 0, height: 40}}>
                                    <Typography variant="overline" display="block" gutterBottom
                                      style={{color: '#757575', margin: 0, fontSize: 11, textAlign: 'left', paddingLeft: 10}}
                                    >
                                      {item2.cpf}
                                    </Typography>
                                  </td>
                                </tr>
                                )}
                              </tbody>
                            )}
                          </table>
                        </div>
                        )
                      }
                      </Grid>  
                    </Grid>
                  </div>

                  <div className="page-break" />
                  <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                    <Typography
                      variant="overline" gutterBottom className="titlePaperForm"                            
                    >
                      Planos Contratados
                    </Typography>
                  </div>

                  <div className="formPrintFields">
                    {
                      this.state.companyData.precoPlano && (
                        this.state.companyData.precoPlano.map((item, index) =>
                    <div key={index}>
                      <Grid container spacing={2} className="infoPlano">
                        <div className="page-break" />
                        <Grid item xs={6} sm={6} md={6} lg={6} className="atribInfoPlano">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Plano:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            {item.plano}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribInfoPlano">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Valor Titular:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            R$ {item.valorTitular}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribInfoPlano">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Valor Dependente:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            R$ {item.valorDependente}
                          </Typography>
                        </Grid>

                        <div className="page-break" />
                        <Grid item xs={2} sm={2} md={2} lg={2} className="atribInfoPlano">
                          <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                            <strong>Valor Agregado:</strong>
                          </Typography>
                          <Typography variant="overline" display="block" gutterBottom>
                            R$ {item.valorAgregado}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                        )
                      )
                    }
                  </div>

                  <div className="page-break" />
                  <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                    <Typography
                      variant="overline" gutterBottom className="titlePaperForm"                            
                    >
                      Corretora e Vendedor
                    </Typography>
                  </div>

                  <div className="formPrintFields">
                    <Grid container spacing={2} className="infoPlano">
                      <div className="page-break" />
                      <Grid item xs={5} sm={5} md={5} lg={5} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Nome Corretora:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.state.companyData.broker}
                        </Typography>
                      </Grid>

                      <div className="page-break" />
                      <Grid item xs={5} sm={5} md={5} lg={5} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Nome Vendedor:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.state.companyData.salesman}
                        </Typography>
                      </Grid>

                      <div className="page-break" />
                      <Grid item xs={2} sm={2} md={2} lg={2} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Código S4E:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.state.companyData.salesmanCode}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>

                  <div className="page-break" />
                  <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                    <Typography
                      variant="overline" gutterBottom className="titlePaperForm"                            
                    >
                      Informações do Pagamento
                    </Typography>
                  </div>

                  <div className="page-break" />
                  <div className="formPrintFields">
                    <Grid container spacing={2} className="infoPlano">
                      <Grid item xs={4} sm={4} md={4} lg={4} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Valor Total:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {
                            this.state.companyData.responsibility && (
                              'R$ '+this.state.companyData.responsibility.replace(',', '.')
                            )
                          }
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} lg={4} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Forma de Pagamento:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                        {
                          this.state.companyData.boletoId ? ("BOLETO BANCÁRIO") : (
                            this.state.companyData.reteveAdesao === true ? ("ADESÃO RETIDA PELO VENDEDOR") : (
                              "NÃO ENCONTRADO"
                            )
                          )
                        }
                        </Typography>
                      </Grid>
                      {
                        this.state.companyData.boletoId && (
                          this.state.companyData.vencimentoBoleto && (
                      <Grid item xs={4} sm={4} md={4} lg={4} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Vencimento:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.state.companyData.vencimentoBoleto}
                        </Typography>
                      </Grid>
                          )
                        )
                      }
                      {
                        this.state.companyData.boletoId && (
                          this.state.companyData.situacaoBoleto && (
                      <Grid item xs={4} sm={4} md={4} lg={4} className="atribInfoPlano">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Situação:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.state.companyData.situacaoBoleto}
                        </Typography>
                      </Grid>
                          )
                        )
                      }
                    </Grid>
                  </div>

                  <div className="page-break" />
                  {
                    this.state.companyData.companyIPConfirm && (
                  <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                    <Typography
                      variant="overline" gutterBottom className="titlePaperForm"                            
                    >
                      Validação
                    </Typography>
                  </div>
                    )
                  }

                  <div className="page-break" />
                  {
                    this.state.companyData.companyIPConfirm && (
                  <div className="formPrintFields">
                    <Grid container spacing={2} className="infoPlano">
                      <Grid item xs={6} sm={6} md={6} lg={6} className="atribValidacao">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Endereço IP:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.state.companyData.companyIPConfirm}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6} className="atribValidacao">
                        <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                          <strong>Data/Hora:</strong>
                        </Typography>
                        <Typography variant="overline" display="block" gutterBottom>
                          {this.formatacaoData()}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                    )
                  }

                </Paper>
              </div>
                )
              }
            </div>

          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.snackbarSuccess} autoHideDuration={5000} onClose={this.snackbarSuccessClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.snackbarSuccessClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSnackbarSuccess}
            </MuiAlert>
          </Snackbar>
        </div>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalConfirmOpen}
          onClose={this.handleConfirmClose.bind(this)}
          aria-labelledby="i_modalConfirm"
        >
          <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
          <DialogContent>
            {/* Conteúdo para pergunta */
              this.state.modalConfirmQuestion === true ? (
            <DialogContentText>
              {this.state.modalConfirmQuestionContent}
            </DialogContentText>
              ) : (/* Conteúdo para cancelar */
                this.state.modalConfirmActionType === 'cancel' ? (
            <div>
            {/* O cancelamento não baixa o boleto: quem cancela precisa pedir a baixa na P4X */
              this.temBoletoEmAberto() ? (
            <Alert severity="warning" style={{marginBottom: 15}}>
              Esta proposta tem boleto em aberto
              {this.state.companyData.nossoNumero ? ' (nosso número ' + this.state.companyData.nossoNumero + ')' : ''}
              {this.state.companyData.vencimentoBoleto ? ', com vencimento em ' + this.state.companyData.vencimentoBoleto : ''}.
              O cancelamento aqui <strong>não baixa o boleto</strong>: solicite a baixa na P4X para o cliente não pagar por engano.
            </Alert>
              ) : ('')
            }
            <TextField
              error={this.state.errorRequest}
              fullWidth
              select
              label="Motivo do cancelamento"
              variant="outlined"
              size="small"
              SelectProps={{
                native: true,
              }}
              value={this.state.fieldCancel}
              disabled={this.state.modalConfirmButtonLoading}
              onChange={this.updateFieldCancel.bind(this)}
            >
            <option value="null">Selecione um motivo</option>
            {this.state.cancellationsList.map((item, index) =>
              <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
            )}
            </TextField>
            </div>
                ) : (/* Conteúdo para pendência */
                  this.state.modalConfirmActionType === 'pending' ? (
            <TextField
              error={this.state.errorRequest}
              fullWidth
              select
              label="Motivo do indeferimento"
              variant="outlined"
              size="small"
              SelectProps={{
                native: true,
              }}
              value={this.state.fieldPending}
              disabled={this.state.modalConfirmButtonLoading}
              onChange={this.updateFieldPending.bind(this)}
            >
              <option value="null">Selecione um motivo</option>
              {this.state.pendencyList.map((item, index) =>
                <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
              )}
            </TextField>
                  ) : (/* Conteúdo ao mandar para análise */
                    this.state.modalConfirmActionType === 'analyze' ? (
                      this.state.companyData.companyConfirm === null ? (
            <DialogContentText>
              Esta proposta consta como <strong>NÃO CONFIRMADA</strong> pela empresa. Ficará aguardando a confirmação onde a mesma será enviada automaticamente para análise.
            </DialogContentText>
                      ) : (
            <DialogContentText>
              Esta proposta consta como <strong>CONFIRMADA</strong> pela empresa e será encaminhada para análise.
            </DialogContentText>
                      ) 
                    ) : (
                      this.state.modalConfirmActionType === 'sus' ? (
            <div>
              {
                this.state.msgSus.length > 0 && (
              <DialogContentText>
                {this.state.msgSus}
              </DialogContentText>
                )
              }

              {
                this.state.msgUserTable.length > 0 && (
              <DialogContentText>
                {this.state.msgUserTable}
              </DialogContentText>
                )
              }

              {
                this.state.msgContinue && (
              <DialogContentText>
                <br/>
                Deseja continuar?
              </DialogContentText>
                )
              }
            </div>
                      ) : (
                        this.state.modalConfirmActionType === 'activate' ? (
            <div>
              {
                this.state.msgSus.length > 0 && (
              <DialogContentText>
                {this.state.msgSus}
              </DialogContentText>
                )
              }

              {
                this.state.msgUserTable.length > 0 && (
              <DialogContentText>
                {this.state.msgUserTable}
              </DialogContentText>
                )
              }

              {
                this.state.msgContinue && (
              <DialogContentText>
                <br/>
                Deseja continuar?
              </DialogContentText>
                )
              }
            </div>
                        ) : (
                          this.state.modalConfirmActionType === 'email' ? (
            <DialogContentText>
              {this.state.modalConfirmQuestionContent}
            </DialogContentText>
                          ) : ('')
                        )
                      )
                    )
                  )
                )
              )
            }
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.handleConfirmClose.bind(this)}
            >
              Fechar
            </Button>

            {/* Botão para pergunta */
              this.state.modalConfirmQuestion === true ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionsModal.bind(this)}
              >
                {this.state.modalConfirmButton}
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : (/* Botão para cancelar */
                this.state.modalConfirmActionType === 'cancel' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionCancellationsDB.bind(this)}
              >
                CANCELAR PROPOSTA
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                ) : (/* Botão para pendência */
                  this.state.modalConfirmActionType === 'pending' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionPendencyDB.bind(this)}
              >
                INDEFERIR PROPOSTA
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                  ) : (/* Botão para mandar para análise */
                    this.state.modalConfirmActionType === 'analyze' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendAnalyze.bind(this)}
              >
                {
                  this.state.companyData.companyConfirm === null ? ("CONFIRMAR") : ("ENVIAR PARA ANÁLISE")
                }
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                    ) : (
                      this.state.modalConfirmActionType === 'activate' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendS4.bind(this)}
              >
                ATIVAR
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                      ) : (
                        this.state.modalConfirmActionType === 'sus' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.beforeSendS4.bind(this)}
              >
                ATIVAR
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                        ) : (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendEmail.bind(this)}
              >
                {this.state.modalConfirmButton}
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                        )
                      )
                    )
                  )
                )
              )
            }

          </DialogActions>
        </Dialog>
      </MainLayout>
    );

  }

}

ResumoPropostaPJ.propTypes = {
  history: PropTypes.object
};

export default withRouter(ResumoPropostaPJ);